var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-title"},[_c('img',{staticClass:"icon-title",attrs:{"src":require("@/assets/imgs/screen/icon-title.png"),"alt":""}}),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }